/* Bundle entry (client-framework.md CF10 big-bang) — the vanilla shell booted
   app.ts's init(document); the React shell mounts <App/> into #root. All state,
   data loading, and chrome live under ./react/shell. */
import { createRoot } from "react-dom/client";
import { App } from "./react/shell/App";

const root = document.getElementById("root");
if (root) createRoot(root).render(<App />);
